module.exports = new __parcel__URL__("newyork_banner.6c90c035.png").toString();